import { Component, computed, input } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-forza-link-form-field",
  imports: [UiKitModule],
  templateUrl: "./forza-link-form-field.component.html",
  styleUrl: "./forza-link-form-field.component.scss",
  standalone: true,
})
export class ForzaLinkFormFieldComponent {
  forzaId = input<string | null>(null);

  valid = input(false);

  forzaLink = computed(() => {
    if (!this.forzaId() || !this.valid()) {
      return null;
    }

    return `https://draeger.sharepoint.com/sites/forza-${this.forzaId()}`;
  });
}
